
import React from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { AllowedAccess } from 'react-permission-role'
import { Button, Card, CardContent, Grid } from '@mui/material'

import { LinearLoading } from 'common';
import { useFechInitLegalLeasesManagements } from './hooks'
import { ManagementsTable } from './ManagementsTable';

export const LegalLeasesManagements = () => {

    const location = useLocation();
    const paramsURL = useParams();
    const useFetchInit = useFechInitLegalLeasesManagements({location, paramsURL})

    const {
        // globalStates,
        FetchData,
        //------------- Actions
        Actions
    } = useFetchInit
    
    const { fetchAllManagements } = FetchData
    const { loadingFetchManagements } = fetchAllManagements
    const {handleClickNewManagement} = Actions

    return (
        <AllowedAccess permissions={['116_ARRENDAMIENTOS_GESTIONES']} renderAuthFailed={<p>Error</p>}>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Card style={{zIndex:'1'}}>
                        <CardContent>
                            <div className='h4 mt-1 mb-1'> Otras Gestiones</div>
                            <div className="border-bottom border-dark"></div>
                            {loadingFetchManagements && ( <LinearLoading /> )}

                            <div className="d-flex justify-content-end pt-4">
                                <Button
                                    style={{background: "#4b4b4c"}} variant="contained" type="button" 
                                    onClick={() => handleClickNewManagement()}
                                >
                                    <i className="fa-solid fa-plus"></i> &nbsp;  Nueva Gestion
                                </Button>
                            </div>
                            
                            <div className="pt-4"></div>
                            <ManagementsTable useFetchInit={useFetchInit} />
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </AllowedAccess>
    )
}
